<template>
    <div class="flex_start mb-12" style="height: 56px">
        <div class="num-title">
            <img src="../../assets/image/title_bg.png" alt="" />
            <div class="num">{{ num }}</div>
        </div>
        <div class="num-title-text">
            {{ title }}
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            num: { type: String, default: '' },
            title: { type: String, defalut: '' },
        },
    }
</script>

<style lang="scss" scoped>
    .num-title {
        position: absolute;
        top: -6px;
        left: 12px;
        width: 36px;
        height: 56px;
        border-radius: 2px 0 2px 2px;
        .num {
            position: absolute;
            top: 16px;
            left: 8px;
            font-weight: 500;
            font-size: 20px;
            color: #ffffff;
        }
    }
    .num-title-text {
        position: absolute;
        top: 16px;
        left: 56px;
        font-weight: 500;
        font-size: 16px;
        color: #23324a;
    }
</style>
